import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import BlockContextMenu from 'components/common/BlockContextMenu/BlockContextMenu';
import ProtectedImage from '../ProtectedImage/ProtectedImage';
import { ThumbnailBtn } from './ThumbnailButton.styles';

const ThumbnailButton = ({ imgSrc, isSelected, altText = '', onThumbClick = noop, className = '' }) => {
  return (
    <ThumbnailBtn type={'button'} className={`${className} ${isSelected ? 'selected' : ''}`} onClick={onThumbClick}>
      <BlockContextMenu className={'block-context'}>
        <ProtectedImage src={imgSrc} altText={altText} className={'thumbnail'} />
      </BlockContextMenu>
    </ThumbnailBtn>
  );
};

ThumbnailButton.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  altText: PropTypes.string,
  onThumbClick: PropTypes.func,
  className: PropTypes.string,
};

export default ThumbnailButton;
